import { MedicalDataAccessAuthorization } from '@dreryk/egabinet-patient-frontend-api';

import { Link, ModalWidth, RemoveIcon, ShowModalEventInterceptor } from '@dreryk/react-components';

import { patientConsentsAndAuthorizationsTranslationKeys } from '../../../translations';

import { useMedicalDataAccessAuthorizationWithdrawCommand } from './WithdrawMedicalDataAccessAuthorizationAction.hooks';
import { WithdrawMedicalDataAccessAuthorizationActionContent } from './WithdrawMedicalDataAccessAuthorizationActionContent';

type WithdrawMedicalDataAccessAuthorizationActionProps = {
   readonly id: MedicalDataAccessAuthorization['id'];
   readonly firstName: MedicalDataAccessAuthorization['firstName'];
   readonly lastName: MedicalDataAccessAuthorization['lastName'];
};

const WithdrawMedicalDataAccessAuthorizationAction = (
   props: WithdrawMedicalDataAccessAuthorizationActionProps
): JSX.Element => {
   const { executeAsync: withdrawConsent } = useMedicalDataAccessAuthorizationWithdrawCommand(props.id);

   return (
      <ShowModalEventInterceptor
         testId={'medicalTreatmentDataAccessWithdrawAuthorization'}
         shouldShowModal
         title={patientConsentsAndAuthorizationsTranslationKeys.authorizations.removeAuthorization}
         confirmationButtonLabel={
            patientConsentsAndAuthorizationsTranslationKeys.authorizations.confirmWithdrawAuthorization
         }
         content={
            <WithdrawMedicalDataAccessAuthorizationActionContent
               lastName={props.lastName}
               firstName={props.firstName}
            />
         }
         onConfirm={async (resolve, reject) => withdrawConsent().then(resolve).catch(reject)}
         modalWidth={ModalWidth.NORMAL}
      >
         <Link testId={'remove'} icon={<RemoveIcon />} />
      </ShowModalEventInterceptor>
   );
};

export { WithdrawMedicalDataAccessAuthorizationAction };
